import { createSlice } from "@reduxjs/toolkit";
import {
  requestInboundMailThunk,
  getCompanyInfoThunk,
  getCompaniesThunk,
} from "../actions/company.action";
import { ICompany } from "../../models/company.model";

export interface CompanyState {
  companies: ICompany[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: CompanyState = {
  companies: [],
  loading: false,
  error: null,
};

// Company slice
const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestInboundMailThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(requestInboundMailThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(requestInboundMailThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(getCompanyInfoThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanyInfoThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getCompanyInfoThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(getCompaniesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompaniesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.companies = action.payload.data;
      })
      .addCase(getCompaniesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const {} = companySlice.actions;
export default companySlice.reducer;
